import { View } from "extensions/marionette";
import { captureException } from "extensions/sentry";

import savedFilterTemplate from "./savedFilter.jst";

export const SavedFilter = View.extend({
    className: "filter",
    template: savedFilterTemplate,
    attributes() {
        return {
            "data-action": `apply:${this.model.id}`
        };
    },
    events: {
        click(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Read action from the event target or default to applying saved filter
            this.triggerMethod("action", e.target.dataset.action || e.target.parentElement.dataset.action || this.el.dataset.action);
        }
    },
    
    templateContext() {
        let include = [];
        let exclude = [];
        
        try {
            include = Object.entries(this.model.getIncludedQualifiers());
            exclude = Object.entries(this.model.getExcludedQualifiers());
        } catch (error) {
            captureException(error);
        }
        
        return {
            include,
            exclude
        };
    }
});
